import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {PersistConfig} from 'redux-persist'
import {persistReducer} from 'redux-persist'
import persistStorage from 'redux-persist/lib/storage'

interface IMusicHomeSearchFilter {
  isFocused?: boolean;
  value?: string;
}

interface IMusicHomeStore {
  activeMenu?: MusicHomeMenuType[];
  search?: IMusicHomeSearchFilter;
}

type MusicHomeMenuMobileType = "mobile.search";
type MusicHomeMenuType = MusicHomeMenuMobileType;

const initialMusicHomeState: IMusicHomeStore = {
  // we may want to load persisted filter data here
};

export const musicHomeSlice = createSlice({
  name: `musicHome`,
  initialState: initialMusicHomeState,

  reducers: (create) => ({
    toggleActiveMenuReducer: create.reducer((store: IMusicHomeStore, action: PayloadAction<MusicHomeMenuType>) => {
      const menuName = action.payload;

      let filterMenu = [
        ...(store.activeMenu ?? []),
      ];

      const isMenuAlreadyActive: boolean = filterMenu
        .includes(menuName);

      if (isMenuAlreadyActive) {
        // remove from existing active menu list
        filterMenu = filterMenu
          .filter((existingMenuName) => existingMenuName !== menuName);
      } else {
        // add to existing filter menus active
        filterMenu.push(menuName);
      }

      store.activeMenu = filterMenu;
    }),
    removeActiveMenuReducer: create.reducer((store: IMusicHomeStore, action: PayloadAction<MusicHomeMenuType>) => {
      const menuName = action.payload;

      const inputActiveMenu = [
        ...(store.activeMenu ?? []),
      ];

      const updatedActiveMenu = [
        ...inputActiveMenu
          .filter((activeMenuName) => activeMenuName !== menuName)
      ];

      store.activeMenu = updatedActiveMenu;
    }),
    setSearchFieldFocusReducer: create.reducer((store: IMusicHomeStore, action: PayloadAction<boolean>) => {
      store.search = {
        ...(store.search ?? {}),
        isFocused: action.payload,
      };
    }),
    filterSearchSetValueReducer: create.reducer((store: IMusicHomeStore, action: PayloadAction<string>) => {
      store.search = {
        ...(store.search ?? {}),
        value: action.payload,
      };
    }),
    resetFilterSearchReducer: create.reducer((store) => {
      store.search = initialMusicHomeState.search;
    }),
  }),
  selectors: {
    isMobileSearchFieldActiveSelector: (store: IMusicHomeStore) => !!store.activeMenu?.includes('mobile.search'),
    doesMobileSearchFieldHaveTextSelector: (store: IMusicHomeStore) => !!store.search?.value?.trim()?.length,
    isSearchFieldFocusedSelector: (store: IMusicHomeStore) => !!store.search?.isFocused,
    searchTextSelector: (store: IMusicHomeStore) => store.search?.value ?? '',
  },
});

const musicHomePersistConfig: PersistConfig<IMusicHomeStore> = {
  key: `musicHome`,
  storage: persistStorage,
  whitelist: [
    `search`,
  ],
};

const musicHomeBaseReducer = musicHomeSlice.reducer;
export const musicHomeReducer = persistReducer<IMusicHomeStore>(musicHomePersistConfig, musicHomeBaseReducer);
